import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Award } from 'lucide-react';
const notThis = ['This is not a random collection of drawing exercises copied from the internet.', 'This is not a theoretical book you have to rewrite before it works in a real class.', 'This is not content designed for a different type of teacher that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-sand border-y border-warmgray" data-id="element-235" data-mp="z26151x0xpsu">
      <div className="max-w-4xl mx-auto text-center" data-id="element-236" data-mp="u333w3nacnvf">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-237" data-mp="u4e9m90ak5p6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-terracotta/10 text-terracotta mb-5" data-id="element-238" data-mp="2fge83o5b9qjd">
            <Award size={26} aria-hidden="true" data-id="element-239" data-mp="2bv76ewx7wsg3" />
          </div>
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-240" data-mp="2gu0ol2ng97ml">
            The Complete Professional System
          </p>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-charcoal" data-id="element-241" data-mp="2kukjs0ogq163">
            Drawing Teacher Ready
          </h2>
          <p className="text-base md:text-lg text-charcoal-soft mb-10" data-id="element-242" data-mp="1t5r3k2y28nwi">
            6 Complete Volumes · 150 Ready-to-Teach Lessons · 5 Strategic
            Bonuses · Everything Ready to Use Today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-243" data-mp="224cm3y3j82xa">
          <motion.div initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-paper p-6 rounded-2xl border border-warmgray" data-id="element-244" data-mp="26x5seqenfjbh">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-245" data-mp="2qjskdfx5wcu8">
                <X className="text-terracotta-dark shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-246" data-mp="2mhxlei2pebjm" />
                <p className="text-charcoal-muted text-sm" data-id="element-247" data-mp="1yswh970wlmk5">{item}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-terracotta/10 p-6 rounded-2xl border border-terracotta/30" data-id="element-248" data-mp="1tvmnxgae8qr1">
            <div className="flex items-start gap-3" data-id="element-249" data-mp="3mokl3qkek7jt">
              <Check className="text-terracotta-deep shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-250" data-mp="3qrh4vkloi9pc" />
              <p className="text-charcoal font-medium text-base leading-relaxed" data-id="element-251" data-mp="3cu2eacjovvvs">
                This is a complete professional library, so you walk into each
                class completely prepared, confident, and ready to teach a
                session your students feel.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}